import lodashGet from "lodash/get";

import { httpPost } from "@/services/api.service";
import { BASE_URL } from "@/common/constants/api";

export { _getSearchLibrary as getSearchLibrary };

const _getSearchLibrary = async (count, nextToken) => {
  try {
    if (!count) {
      console.error("Unable to get search library, count not set.");
      return false;
    }

    let libraryQuery =
      "query MyQuery($count: Int!) { searches { seeristSearches(count: $count) { searches { id name description updatedAt userId params } nextToken } } }";

    if (nextToken) {
      libraryQuery =
        "query MyQuery($count: Int!, $nextToken: String!) { searches { seeristSearches(count: $count, nextToken: $nextToken) { searches { id name description updatedAt userId params } nextToken } } }";
    }

    const RESULT = await httpPost({
      url: BASE_URL + "/v2/savedsearch",
      data: {
        query: libraryQuery,
        variables: {
          count: count,
          ...(nextToken && { nextToken: nextToken }),
        },
      },
    });
    const { data } = JSON.parse(RESULT);

    if (lodashGet(data, "data.searches.seeristSearches")) {
      return data.data.searches.seeristSearches;
    }

    console.error(
      "Issue getting search library info in searchLibrary.service.js. No data.searches found."
    );
    return null;
  } catch (error) {
    console.error("Unable to retrieve search library", error);
    return false;
  }
};
